<template>
  <div class="box">
    <div class="floatBox">
      <div class="searchBox">
        <div class="search">
          <img src="../assets/search.png" alt />
          <input type="text" id="searchShop" placeholder="输入店铺名称" />
        </div>
        <div class="clickSearch" v-on:click="SearchShop">搜索</div>
      </div>
      <div class="typeBox">
        <yd-button
          @click.native="show1 = true"
          size="large"
          bgcolor="#3370FF"
          color="#fff"
        >{{shopTypeName}}</yd-button>
        <yd-actionsheet :items="myItems1" v-model="show1"></yd-actionsheet>
      </div>
    </div>

    <!-- <div class="LeftBox">
      <div :class="'全部分类'==shopTypeName?'clickType':''" v-on:click="clickType('全部分类')">全部分类</div>
      <div
        v-for="(item,index) in ShopClassList"
        :key="index"
        :class="item==shopTypeName?'clickType':''"
        v-on:click="clickType(item)"
      >{{item}}</div>
    </div>-->
    <div>
      <baidu-map
        id="Map"
        class="bm-view"
        ak="QGGvEs2B684koGNEfUirzuoWUMzirbaQ"
        :center="center"
        :zoom="zoom"
        @ready="header"
        @dragend="draggingaaa"
      >
        <!-- @dragend="draggingaaa" -->
        <bml-marker-clusterer :averageCenter="true">
          <!-- <bm-marker
            :dragging="dragging"
            @dragend="dragend"
            :position="People"
            animation="BMAP_ANIMATION_BOUNCE"
            :icon="{url: centerIMG, size: { width: 40, height:50} ,}"
          ></bm-marker> -->
          <!--   -->
        </bml-marker-clusterer>
        <bm-driving
          :start="startLocation"
          :end="endLocation"
          :auto-viewport="true"
          :panel="false"
          @markersset="markersset"
        ></bm-driving>
        <bm-control>
          <div class="btn" @click="toggle" v-if="process">返回</div>
        </bm-control>
      </baidu-map>
      <div class="locationImg" @click="tolocation">
        <img :src="toLocation" alt />
      </div>
      <div class="moveCenter" v-if="moveCenterShow">
        <img :src="moveCenter" alt="">
      </div>
    </div>

    <Nav tabindex="1"></Nav>
  </div> 
</template>

<script>
import { BmlMarkerClusterer } from "vue-baidu-map";
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmMarker from "vue-baidu-map/components/overlays/Marker.vue";
import BmLabel from "vue-baidu-map/components/overlays/Label.vue";
import BmInfoWindow from "vue-baidu-map/components/overlays/InfoWindow.vue";
import bmDriving from "vue-baidu-map/components/search/Driving.vue";
import bmControl from "vue-baidu-map/components/controls/Control.vue";
import $ from "jquery";
import Nav from "../components/Nav";
export default {
  name: "",
  data() {
    return {
      moveCenterShow: true,
      massClear: false,
      dragging: false,
      shopTypeList: [],
      ShopClassList: [],
      shopTypeName: "全部分类",
      zoom: 16,
      show: false,
      center: { lng: this.$store.state.log, lat: this.$store.state.lat },
      People: { lng: this.$store.state.log, lat: this.$store.state.lat },
      startLocation: { lng: this.$store.state.log, lat: this.$store.state.lat },
      endLocation: { lng: "", lat: "" },
      initialize: { lng: this.$store.state.log, lat: this.$store.state.lat }, //初始化位置
      positionList: [],
      a: false,
      tabList: [1, 0, 0],
      closeOnClick: false,
      centerIMG: require("../assets/fox.gif"),
      centerIMG2: require("../assets/allot2.png"),
      toLocation: require("../assets/toLocation.png"),
      moveCenter: require("../assets/moveCenter.png"),
      tabImg: [
        {
          showNow: require("../assets/index01.png"),
          showNo: require("../assets/index02.png")
        },
        {
          showNow: require("../assets/map01.png"),
          showNo: require("../assets/map02.png")
        },
        {
          showNow: require("../assets/us01.png"),
          showNo: require("../assets/us02.png")
        }
      ],
      process: false,

      show1: false,
      myItems1: [
        {
          label: "全部分类",
          callback: () => {
            this.clickType("全部分类");
            /* 注意： callback: function() {} 和 callback() {}  这样是无法正常使用当前this的 */
          }
        }
      ]
    };
  },
  components: {
    Nav,
    BaiduMap,
    BmMarker,
    BmInfoWindow,
    BmlMarkerClusterer,
    bmDriving,
    bmControl,
    BmLabel
  },
  created() {},
  mounted() {
    var openid = localStorage.getItem("ZQopenid");
    var UserInfo = localStorage.getItem("ZQUserInfo")
      ? JSON.parse(localStorage.getItem("ZQUserInfo"))
      : "";
    var location = JSON.parse(localStorage.getItem("ZQlocation"));
    this.$store.commit("location", location);
    this.$store.commit("UserInfo", {
      UserInfo: UserInfo
    });
    this.UserInfo = UserInfo;
    this.openid = UserInfo.openid;
    this.$store.commit(
      "UserSelf",
      JSON.parse(localStorage.getItem("ZQUserSelf"))
    );
    $("#Map>div").css({
      height: "100%"
    });
  },
  activated() {},
  methods: {
    markersset(e) {
      e.map(item => {
        this.map.removeOverlay(item.marker);
      });
    },
    //恢复定位
    tolocation() {
      this.People = this.initialize;
      this.startLocation = this.initialize;
      this.makeInfowindow();
    },
    draggingaaa(a) {
      // console.log("aaaaa");
     
      //  this.startLocation =this.map.getViewport().center
      console.log("移动结束")
      console.log()
      if (this.process) {
        return;
      }
      this.moveCenterShow=true
      this.People=this.map.getViewport().center
      this.dragend(this.map.getViewport().center)
      // this.People = { lng: a.point.lng, lat: a.point.lat };
    },
    //移动结束获取周围店铺
    dragend(a) {
      // this.People=this.map.getViewport().center
      // this.startLocation =this.map.getViewport().center
      if (!this.$store.state.loading) {
        this.shopTypeName = "全部分类";
        // this.$store.commit("showLoading", true); //显示加载图标
        this.$http
          .get("/api/shop/get_fujin_shop", {
            params: {
              log: this.map.getViewport().center.lng,
              lat: this.map.getViewport().center.lat
            }
          })
          .then(res => {
            if (res.data.code == 1) {
              this.shopTypeList = [];
              if (!res.data.data || res.data.data.action.length == 0) {
                this.$store.commit("showLoading", false); //隐藏加载图标
                return;
              }
              res.data.data.action.map(res => {
                res.show = false;
                this.shopTypeList.push([
                  res.longitude,
                  res.latitude,
                  `<div class="showWindow" style="display: flex;justify-content: space-between;align-items: center;">
                <div class='toshop' shopId='` +
                    res.id +
                    `' detail='` +
                    res +
                    `'>
                  <div shopId='` +
                    res.id +
                    `' detail='` +
                    res +
                    `'>` +
                    res.name +
                    `</div>
                  <div shopId='` +
                    res.id +
                    `' detail='` +
                    res +
                    `'>营业：` +
                    res.shop_business_hours +
                    `</div>
                  <div shopId='` +
                    res.id +
                    `' detail='` +
                    res +
                    `'>位置：` +
                    res.shop_area +
                    `</div>
                </div>
                <div class="toPlace" lat="` +
                    res.latitude +
                    `" lng="` +
                    res.longitude +
                    `" style="padding: 0.2rem 0.3rem;border-radius: 0.1rem;color: white;background-color: #cd160d;">导航</div>
              </div>`,
                  res.name
                ]);
              });
              var zoom=this.map.getViewport().zoom
              this.makeInfowindow(zoom);
              this.$store.commit("showLoading", false); //隐藏加载图标
            } else {
              this.$store.commit("showLoading", false); //关闭加载图标
            }
          });
      }
    },
    //搜索
    SearchShop() {
      if (!this.$store.state.loading) {
        this.shopTypeName = "全部分类";
        this.$store.commit("showLoading", true); //显示加载图标
        this.$http
          .get("/api/shop/search_shop", {
            params: {
              name: $("#searchShop").val(),
              log: this.$store.state.log,
              lat: this.$store.state.lat
            }
          })
          .then(res => {
            if (res.data.code == 1) {
              this.shopTypeList = [];
              if (!res.data.data || res.data.data.action.length == 0) {
                this.$store.commit("showLoading", false); //隐藏加载图标
                this.$store.commit("showMsg", {
                  show: true,
                  type: false,
                  msg: '没有查询到该店铺',
                }); //显示领取失败
                return;
              }
              this.center = {
                lng: res.data.data.action[0].longitude,
                lat: res.data.data.action[0].latitude
              };
              res.data.data.action.map(res => {
                res.show = false;
                this.shopTypeList.push([
                  res.longitude,
                  res.latitude,
                  `<div class="showWindow" style="display: flex;justify-content: space-between;align-items: center;">
                <div class='toshop' shopId='` +
                    res.id +
                    `' detail='` +
                    res +
                    `'>
                  <div shopId='` +
                    res.id +
                    `' detail='` +
                    res +
                    `'>` +
                    res.name +
                    `</div>
                  <div shopId='` +
                    res.id +
                    `' detail='` +
                    res +
                    `'>营业：` +
                    res.shop_business_hours +
                    `</div>
                  <div shopId='` +
                    res.id +
                    `' detail='` +
                    res +
                    `'>位置：` +
                    res.shop_area +
                    `</div>
                </div>
                <div class="toPlace" lat="` +
                    res.latitude +
                    `" lng="` +
                    res.longitude +
                    `" style="padding: 0.2rem 0.3rem;border-radius: 0.1rem;color: white;background-color: #cd160d;">导航</div>
              </div>`,
                  res.name
                ]);
              });

              this.makeInfowindow();
              this.$store.commit("showLoading", false); //隐藏加载图标
            } else {
              this.$store.commit("showLoading", false); //关闭加载图标
            }
          });
      }
    },
    toggle() {
      this.endLocation = {};
      this.process = false;
       this.moveCenterShow=true
    },
    toPlace(place) {
      console.log(place);
      // this.endLocation = { lng: 126.6232359800, lat: 45.7213956100 };
      this.process = true;
      this.moveCenterShow=false
      this.endLocation = place;
    },
    header({ BMap, map }) {
      console.log(BMap, map);
      this.BMap = BMap;
      this.map = map;
      this.GetShopClassListList();
      // 百度地图API功能
    },
    //窗口
    makeInfowindow(zoom) {
      this.map.clearOverlays();
      this.map.centerAndZoom(
        new BMap.Point(this.People.lng, this.People.lat),
        zoom?zoom:14
      );
      var data_info = this.shopTypeList;
      console.log("shopTypeList", data_info);
      this.opts = {
        width: 250, // 信息窗口宽度
        height: 80, // 信息窗口高度
        title: "店铺信息", // 信息窗口标题
        enableMessage: true //设置允许信息窗发送短息
      };
      // 创建小车图标
      var pt = new BMap.Point(this.initialize.lng,this.initialize.lat);
      var myIcon = new BMap.Icon(
        this.centerIMG2,
        new BMap.Size(40, 40)
      );
      var marker2 = new BMap.Marker(pt, {
        icon: myIcon
      }); // 创建标注
      this.map.addOverlay(marker2);
      
      for (var i = 0; i < data_info.length; i++) {
        var marker = new BMap.Marker(
          new BMap.Point(data_info[i][0], data_info[i][1])
        ); // 创建标注
        var content = data_info[i][2];
        this.map.addOverlay(marker); // 将标注添加到地图中

        //创建 文本标注
        var opts = {
          position: new BMap.Point(data_info[i][0], data_info[i][1]), // 指定文本标注所在的地理位置
          offset: new BMap.Size(-30, 0) //设置文本偏移量
        };
        var label = new BMap.Label(data_info[i][3], opts); // 创建文本标注对象
        label.setStyle({
          color: "#333333",
          fontSize: "12px",
          height: "20px",
          lineHeight: "20px",
          fontFamily: "微软雅黑",
          background: "#e5e5e5",
          border: "0px"
        });
        this.map.addOverlay(label);

        this.addClickHandler(content, marker);
      }
    },
    //文本标注
    addTextShow() {},
    addClickHandler(content, marker) {
      var that = this;
      marker.addEventListener("click", function(e) {
        that.openInfo(content, e);
      });
    },

    openInfo(content, e) {
      var p = e.target;
      var point = new BMap.Point(p.getPosition().lng, p.getPosition().lat);
      var infoWindow = new BMap.InfoWindow(content, this.opts); // 创建信息窗口对象
      this.map.openInfoWindow(infoWindow, point); //开启信息窗口
      var that = this;
      $(".toPlace").on("click", e => {
        // console.log("aaaa");
        this.People = this.startLocation;
        var lat = $(e.toElement).attr("lat");
        var lng = $(e.toElement).attr("lng");
        // console.log(lat, lng);
        that.toPlace({ lat: lat, lng: lng });
        this.process = true;
      });
      $(".toshop").on("click", e => {
        var shopId = $(e.toElement).attr("shopId");
        var detail = $(e.toElement).attr("detail");
        console.log($(e.toElement));
        that.$router.push({
          path: "shopIndex",
          query: { detail: detail, id: shopId }
        });
        this.process = true;
      });
    },
    //获取店铺分类
    GetShopClassListList() {
      this.$http
        .get("/api/shop/getShopClassListList", {
          params: {}
        })
        .then(res => {
          for (var x in res.data) {
            this.ShopClassList.push(res.data[x]);
            var n = {
              label: res.data[x],
              callback: e => {
                this.clickType(e.label);
                /* 注意： callback: function() {} 和 callback() {}  这样是无法正常使用当前this的 */
              }
            };
            this.myItems1.push(n);
          }
          console.log(JSON.stringify(this.myItems1));
          // this.shopTypeName = this.ShopClassList[0];
          this.GetTypeList();
        });
    },
    clickType(e) {
      $("#Map").click();
      console.log($(".el-dropdown-menu"));
      this.shopTypeName = e;
      this.GetTypeList();
    },
    getAllshop() {
      this.$store.commit("showLoading", true); //显示加载图标
      this.$http
        .get("/api/shop/get_all_shop", {
          params: {
            name: this.shopTypeName
          }
        })
        .then(res => {
          this.shopTypeList = [];
          res.data.data.action.map(res => {
            res.show = false;
            this.shopTypeList.push([
              res.longitude,
              res.latitude,
              `<div class="showWindow" style="display: flex;justify-content: space-between;align-items: center;">
                <div class='toshop' shopId='` +
                res.id +
                `' detail='` +
                res +
                `'>
                  <div shopId='` +
                res.id +
                `' detail='` +
                res +
                `'>` +
                res.name +
                `</div>
                  <div shopId='` +
                res.id +
                `' detail='` +
                res +
                `'>营业：` +
                res.shop_business_hours +
                `</div>
                  <div shopId='` +
                res.id +
                `' detail='` +
                res +
                `'>位置：` +
                res.shop_area +
                `</div>
                </div>
                <div class="toPlace" lat="` +
                res.latitude +
                `" lng="` +
                res.longitude +
                `" style="padding: 0.2rem 0.3rem;border-radius: 0.1rem;color: white;background-color: #cd160d;">导航</div>
              </div>`,
              res.name
            ]);
          });

          this.makeInfowindow();
          this.$store.commit("showLoading", false); //隐藏加载图标
        });
    },
    //获取店铺信息列表
    GetTypeList() {
      if (this.shopTypeName == "全部分类") {
        this.getAllshop();
        return;
      }
      if (!this.$store.state.loading) {
        console.log(this.BMap, this.map);
        this.$store.commit("showLoading", true); //显示加载图标
        this.$http
          .get("/api/shop/getshop_list", {
            params: {
              name: this.shopTypeName
            }
          })
          .then(res => {
            this.shopTypeList = [];
            res.data.data.action.map(res => {
              res.show = false;
              this.shopTypeList.push([
                res.longitude,
                res.latitude,
                `<div class="showWindow" style="display: flex;justify-content: space-between;align-items: center;">
                <div class='toshop' shopId='` +
                  res.id +
                  `' detail='` +
                  res +
                  `'>
                  <div shopId='` +
                  res.id +
                  `' detail='` +
                  res +
                  `'>` +
                  res.name +
                  `</div>
                  <div shopId='` +
                  res.id +
                  `' detail='` +
                  res +
                  `'>营业：` +
                  res.shop_business_hours +
                  `</div>
                  <div shopId='` +
                  res.id +
                  `' detail='` +
                  res +
                  `'>位置：` +
                  res.shop_area +
                  `</div>
                </div>
                <div class="toPlace" lat="` +
                  res.latitude +
                  `" lng="` +
                  res.longitude +
                  `" style="padding: 0.2rem 0.3rem;border-radius: 0.1rem;color: white;background-color: #cd160d;">导航</div>
              </div>`,
                res.name
              ]);
            });

             if (!res.data.data || res.data.data.action.length == 0) {
                this.$store.commit("showLoading", false); //隐藏加载图标
                this.$store.commit("showMsg", {
                  show: true,
                  type: false,
                  msg: '该分类没有店铺',
                }); //显示领取失败
              }


            this.makeInfowindow();
            this.$store.commit("showLoading", false); //隐藏加载图标
          });
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.box {
  height: 100vh;
  display: flex;
  justify-content: flex-start;
  position: relative;
}
.floatBox {
  position: absolute;
  right: 0;
  z-index: 1000;
  width: 100vw;
  display: flex;
  justify-content: flex-start;
  padding-top: 0.3rem;
  padding-right: 0.1rem;
}
.locationImg {
  position: absolute;
  right: 0.5rem;
  bottom: 1.5rem;
  width: 0.7rem;
  height: 0.7rem;
  background: white;
  border-radius: 0.1rem;
  border: 1px solid #e5e5e5;
  box-shadow: 0px 0px 5px #e5e5e5;
  z-index: 100;
  padding: 0.1rem;
}
.locationImg > img {
  width: 100%;
  height: 100%;
}
.searchBox {
  height: 0.8rem;
  // width: 5.8rem;
  width: 70%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  border: 2px solid #e22319;
  background: white;
  opacity: 0.9;
  border-radius: 0.4rem;
  padding-left: 0.3rem;
  font-size: 0.24rem;
  margin: 0 0.1rem 0 0.1rem;
}
.search {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.searchBox img {
  width: 0.5rem;
  height: 0.5rem;
  display: inline-block;
  margin-right: 0.2rem;
}
.searchBox input {
  border: none;
  outline: none;
  -webkit-appearance: none;
}
.clickSearch {
  width: 1.9rem;
  height: 100%;
  background-image: linear-gradient(to right, #e73d35, #bc170f);
  opacity: 1;
  color: white;
  font-size: 0.32rem;
  border-radius: 0.4rem;
  text-align: center;
  line-height: 0.8rem;
}
.typeBox {
  width: 30%;
}
.yd-btn-block {
  height: 0.8rem !important;
  line-height: 0.8rem !important;
  margin-top: 0 !important;
}
.LeftBox {
  width: 1.5rem;
  padding-bottom: 1rem;
  overflow-y: scroll;
  flex-shrink: 0;
}
.LeftBox div {
  background-color: #f7f5f6;
  font-size: 0.26rem;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
}
.clickType {
  background-color: white !important;
}
#Map {
  width: 100vw !important;
  height: 100vh !important;
  overflow: hidden;
  padding-bottom:1rem;
}
#Map > div:nth-child(1) {
  width: 6.5rem !important;
  height: 100vh !important;
}

.btn {
  width: 1.5rem;
  height: 0.7rem;
  line-height: 0.7rem;
  text-align: center;
  background: cornflowerblue;
  color: white;
  margin-top: 1.2rem;
}
.showWindow {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.navigation {
  height: 100%;
  padding-right: 0.3rem;
}
.moveCenter {
  position: fixed;
  left: 50%;
  top: 50%;
  margin-top: -0.75rem;
  margin-left: -0.28rem;
}
.moveCenter > img {
  width: 0.4rem;
  height: 0.4rem;
}
</style>

